import { Matrix4 } from '@math.gl/core';
import { log } from '@luma.gl/webgl';
import ScenegraphNode from './scenegraph-node';
export default class GroupNode extends ScenegraphNode {
  constructor() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    props = Array.isArray(props) ? {
      children: props
    } : props;
    const {
      children = []
    } = props;
    log.assert(children.every(child => child instanceof ScenegraphNode), 'every child must an instance of ScenegraphNode');
    super(props);
    this.children = children;
  }

  add() {
    for (var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++) {
      children[_key] = arguments[_key];
    }

    for (const child of children) {
      if (Array.isArray(child)) {
        this.add(...child);
      } else {
        this.children.push(child);
      }
    }

    return this;
  }

  remove(child) {
    const children = this.children;
    const indexOf = children.indexOf(child);

    if (indexOf > -1) {
      children.splice(indexOf, 1);
    }

    return this;
  }

  removeAll() {
    this.children = [];
    return this;
  }

  delete() {
    this.children.forEach(child => child.delete());
    this.removeAll();
    super.delete();
  }

  traverse(visitor) {
    let {
      worldMatrix = new Matrix4()
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const modelMatrix = new Matrix4(worldMatrix).multiplyRight(this.matrix);

    for (const child of this.children) {
      if (child instanceof GroupNode) {
        child.traverse(visitor, {
          worldMatrix: modelMatrix
        });
      } else {
        visitor(child, {
          worldMatrix: modelMatrix
        });
      }
    }
  }

}
//# sourceMappingURL=group-node.js.map